import { useEffect } from "react";
import { X } from "lucide-react";
import CustomModal from "./CustomModal";
import SecondaryButton from "../Button/SecondaryButton";
import { PrimaryButton } from "../Button/PrimaryButton";

/** In-app replacement for window.confirm; pass children for extra fields (e.g. a reason box). */
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  destructive = false,
  children,
}) => {
  useEffect(() => {
    if (!isOpen || isLoading) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, isLoading, onClose]);

  return (
    <CustomModal isOpen={isOpen}>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        disabled={isLoading}
        className="absolute right-6 top-6 rounded-full p-1 text-gray-800 transition-colors hover:bg-gray-100 disabled:opacity-50 dark:text-gray-200 dark:hover:bg-gray-800"
      >
        <X size={20} />
      </button>

      <div className="flex w-full flex-col gap-5">
        <div className="flex flex-col gap-1.5 pr-8">
          <h3 className="text-base font-bold text-gray-900 dark:text-gray-100">{title}</h3>
          {description && <p className="text-xs text-gray-500 dark:text-gray-400">{description}</p>}
        </div>

        {children}

        <div className="flex w-full gap-3">
          <SecondaryButton title={cancelText} className="w-full" onClick={onClose} disabled={isLoading} />
          <PrimaryButton
            startContent={false}
            className={destructive ? "w-full bg-error-500" : "w-full"}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default ConfirmModal;
